export const SeasonName = {
  1: 'spring',
  2: 'summer',
  3: 'fall',
  4: 'winter',
};
